import { MapStyle } from '@features/map/constants/map-style.constants';
import { FeatureFlag } from '../models/feature-flag';

export const MAP_STYLE_FLAG_ID = 'map-style';

export const NL_SEARCH_MODEL_FLAG_ID = 'nl-search-model';

export const CHATBOT_MODEL_FLAG_ID = 'chatbot-model';

export const FEATURE_FLAGS_REGISTRY: FeatureFlag[] = [
    {
        id: 'llm-debug',
        label: 'LLM Debug',
        description: 'When enabled, shows model, timing, token usage and cost of the last natural-language search under the input.',
        defaultValue: false,
    },
    {
        id: NL_SEARCH_MODEL_FLAG_ID,
        type: 'select',
        label: 'NL Search Model',
        description: 'Provider and model the natural-language search request asks for. Ignored by back ends that do not allow model selection.',
        defaultValue: '',
        options: [
            { value: '', label: 'Server default' },
            { value: 'ANTHROPIC:HAIKU', label: 'Anthropic - Haiku' },
            { value: 'ANTHROPIC:SONNET', label: 'Anthropic - Sonnet' },
            { value: 'ANTHROPIC:OPUS', label: 'Anthropic - Opus' },
            { value: 'ANTHROPIC:HAIKU55', label: 'Anthropic - Haiku 5.5' },
            { value: 'GEMINI:FLASH_LITE', label: 'Gemini - Flash Lite' },
            { value: 'GEMINI:FLASH', label: 'Gemini - Flash' },
            { value: 'GEMINI:PRO', label: 'Gemini - Pro' },
            { value: 'OPENAI:LUNA', label: 'OpenAI - Luna' },
            { value: 'OPENAI:TERRA', label: 'OpenAI - Terra' },
            { value: 'OPENAI:SOL', label: 'OpenAI - Sol' },
        ],
    },
    {
        id: CHATBOT_MODEL_FLAG_ID,
        type: 'select',
        label: 'Chatbot Model',
        description: 'Provider and model the chatbot connection asks for. Applies to the next chatbot connection.',
        defaultValue: '',
        options: [
            { value: '', label: 'Server default' },
            { value: 'anthropic:haiku', label: 'Anthropic - Haiku' },
            { value: 'anthropic:sonnet', label: 'Anthropic - Sonnet' },
            { value: 'anthropic:opus', label: 'Anthropic - Opus' },
            { value: 'anthropic:haiku55', label: 'Anthropic - Haiku 5.5' },
            { value: 'gemini:flash-lite', label: 'Gemini - Flash Lite' },
            { value: 'gemini:flash', label: 'Gemini - Flash' },
            { value: 'gemini:pro', label: 'Gemini - Pro' },
            { value: 'openai:luna', label: 'OpenAI - Luna' },
            { value: 'openai:luna6', label: 'OpenAI - Luna 6' },
            { value: 'openai:terra', label: 'OpenAI - Terra' },
            { value: 'openai:sol', label: 'OpenAI - Sol' },
        ],
    },
    {
        id: 'chatbot-direct-mode',
        label: 'Chatbot Direct Mode',
        description: 'When enabled, NL search input sends queries directly to the chatbot sidebar instead of the inline overlay.',
        defaultValue: false,
    },
    {
        id: 'chatbot-dev-mode',
        label: 'Chatbot Dev Mode',
        description: 'When enabled, shows developer tools in the chatbot header (LLM debug inspector, copy conversation).',
        defaultValue: false,
    },
    {
        id: 'dark-mode',
        label: 'Dark Mode',
        description: 'Switches the app to the dark theme.',
        defaultValue: false,
    },
    {
        id: 'perf-overlay',
        label: 'Performance Overlay',
        description: 'When enabled, shows FPS, recent Angular change-detection ticks and long animation frames in the bottom-left corner.',
        defaultValue: false,
    },
    {
        id: 'show-wip-markers',
        label: 'Show WIP Markers',
        description: 'When enabled, shows construction-tape borders around components with hardcoded or incomplete data bindings.',
        defaultValue: false,
    },
    {
        id: MAP_STYLE_FLAG_ID,
        type: 'select',
        label: 'Map Style',
        description: 'Selects the Google Map cloud style. Prodigy is the default; Google is the plain unstyled basemap.',
        defaultValue: MapStyle.Prodigy,
        options: [
            { value: MapStyle.Prodigy, label: 'Prodigy' },
            { value: MapStyle.Google, label: 'Google' },
            { value: MapStyle.Style1, label: 'Style 1' },
            { value: MapStyle.Style3, label: 'Style 3' },
            { value: MapStyle.PoiDark, label: 'POI Dark' },
        ],
    },
];
